import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step2 } from '../../../../../shared/models/component-messages/simp_in/step2';
import { ObjectToJsonStepperCreatorService } from '../../../../../shared/services/object-to-json-stepper-creator.service';
import { Initial } from '../../models/Initial';

@Component({
	selector: 'app-step2',
	templateUrl: './step2.component.html'
})
export class Step2Component implements OnInit {
	@Input() fnSimpleInitial: Initial;
	@Input() parentForm: FormGroup;
	
	@Input() disabled: boolean;
	@Input() uid = '';
	@Input() linkForRouter: string;
	public step2 = new Step2();

	constructor(public objectToJsonStepperCreatorService: ObjectToJsonStepperCreatorService) {}

	public ngOnInit() {}

	public getUid() {
		return this.uid;
	}
}
